module.exports = __webpack_public_path__ + "static/media/goodnest_app7.688956dc.jpg";